function lvInitTodo() {
  [initReveals, initContadores, initVariantes, initFaq, initGaleria, initComparadores, initComprarAhora].forEach(function (fn) {
    try { fn(); } catch (e) { console.error('[lv-scripts]', fn.name, e); }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', lvInitTodo);
} else {
  lvInitTodo();
}

function initReveals() {
  var els = document.querySelectorAll('.lv-reveal, .lv-reveal-scale');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('lv-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-lv-delay') || 0;
        setTimeout(function () { entry.target.classList.add('lv-visible'); }, Number(delay));
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function initContadores() {
  var nums = document.querySelectorAll('[data-lv-contador]');
  if (!nums.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      obs.unobserve(el);
      var target = parseFloat(el.getAttribute('data-lv-contador'));
      var suffix = el.getAttribute('data-lv-sufijo') || '';
      var decimals = el.getAttribute('data-lv-decimales') ? Number(el.getAttribute('data-lv-decimales')) : 0;
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = target * eased;
        el.textContent = value.toFixed(decimals).replace('.', ',') + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        el.textContent = target.toFixed(decimals).replace('.', ',') + suffix;
      } else {
        requestAnimationFrame(step);
      }
    });
  }, { threshold: 0.4 });
  nums.forEach(function (el) { obs.observe(el); });
}

function initVariantes() {
  document.querySelectorAll('[data-lv-producto]').forEach(function (wrap) {
    var dataEl = wrap.querySelector('[data-lv-variantes-json]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var selects = wrap.querySelectorAll('[data-lv-opcion]');
    var idInput = wrap.querySelector('[data-lv-variant-id]');
    var priceEl = wrap.querySelector('[data-lv-precio]');
    var compareEl = wrap.querySelector('[data-lv-precio-comparado]');
    var addBtn = wrap.querySelector('[data-lv-add]');
    var buyBtn = wrap.querySelector('[data-lv-comprar-ahora]');

    function currentSelection() {
      var sel = [];
      selects.forEach(function (s) { sel.push(s.value); });
      return sel;
    }
    function findVariant(sel) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === sel[i]; });
      });
    }
    function money(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
    function update() {
      var v = findVariant(currentSelection());
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addBtn.getAttribute('data-lv-texto-disponible') : addBtn.getAttribute('data-lv-texto-agotado');
      }
      if (buyBtn) {
        buyBtn.disabled = !v.available;
        buyBtn.textContent = v.available ? buyBtn.getAttribute('data-lv-texto-disponible') : buyBtn.getAttribute('data-lv-texto-agotado');
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  });
}

function initGaleria() {
  document.querySelectorAll('[data-lv-galeria-principal]').forEach(function (principal) {
    var wrap = principal.closest('.lv-producto-galeria');
    if (!wrap) return;
    var minis = wrap.querySelectorAll('[data-lv-galeria-mini]');
    var img = principal.querySelector('img');
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        if (!img) return;
        img.src = mini.getAttribute('data-src');
        minis.forEach(function (m) { m.classList.remove('lv-galeria-mini-activa'); });
        mini.classList.add('lv-galeria-mini-activa');
      });
    });
  });
}

function initComparadores() {
  document.querySelectorAll('[data-lv-comparador]').forEach(function (wrap) {
    var antes = wrap.querySelector('.lv-comparador-antes');
    var linea = wrap.querySelector('.lv-comparador-linea');
    var handle = wrap.querySelector('.lv-comparador-handle');
    if (!antes || !handle) return;

    function setPct(pct) {
      pct = Math.max(0, Math.min(100, pct));
      antes.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
      if (linea) linea.style.left = pct + '%';
    }

    function pctFromEvent(clientX) {
      var rect = wrap.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    var dragging = false;
    function onMove(e) {
      if (!dragging) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      setPct(pctFromEvent(x));
    }
    function startDrag(e) {
      dragging = true;
      onMove(e);
    }
    function stopDrag() { dragging = false; }

    wrap.addEventListener('pointerdown', function (e) { dragging = true; setPct(pctFromEvent(e.clientX)); });
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', stopDrag);
    wrap.addEventListener('touchstart', startDrag, { passive: true });
    window.addEventListener('touchmove', onMove, { passive: true });
    window.addEventListener('touchend', stopDrag);

    setPct(50);
  });
}

function initComprarAhora() {
  document.querySelectorAll('[data-lv-comprar-ahora]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var wrap = btn.closest('[data-lv-producto]');
      if (!wrap) return;
      var idInput = wrap.querySelector('[data-lv-variant-id]');
      if (!idInput || !idInput.value) return;

      var textoOriginal = btn.textContent;
      var textoCargando = btn.getAttribute('data-lv-texto-cargando') || textoOriginal;
      btn.disabled = true;
      btn.textContent = textoCargando;

      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: idInput.value, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'checkout';
        })
        .catch(function (err) {
          console.error('[lv-scripts] comprar ahora', err);
          btn.disabled = false;
          btn.textContent = textoOriginal;
          alert((err && err.description) || 'No se ha podido procesar la compra. Inténtalo de nuevo.');
        });
    });
  });
}

function initFaq() {
  document.querySelectorAll('[data-lv-faq-item]').forEach(function (item) {
    var btn = item.querySelector('[data-lv-faq-pregunta]');
    var panel = item.querySelector('[data-lv-faq-respuesta]');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var open = item.classList.toggle('lv-faq-abierto');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.style.maxHeight = open ? panel.scrollHeight + 'px' : null;
    });
  });
}
